import React, { useState } from "react";
import {
  CardContent,
  FormConsentText,
  FormContentContainer,
  FormGroup,
  FormHeaderContainer,
  FormRow,
  FormSubmitButton,
  FormTextInput,
  SubscribeIcon,
  SubscribeSubtitle,
  SubscribeTitle,
  SubscriptionCard,
} from "./styles";
import { REGEX_VALIDATION_PATTERNS } from "consts/validations";
import { requestOptions, requestURL } from "./constants";

export default function SubscriptionForm({ formIndex = 0 }) {
  const [showSubmitSuccess, setShowSubmitSuccess] = useState(false);

  const getCurrentPageInfo = () => {
    if (typeof window !== "undefined") {
      const pageUri = window.location.href;
      let pageName = window.location.pathname;

      if (pageName?.length === 1 && pageName === "/") {
        pageName = "Homepage";
      } else {
        pageName = pageName.slice(1);
      }

      return {
        pageName,
        pageUri,
      };
    }
  };

  async function submitForm(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    const formattedData = [...formData].reduce((acc, [key, value]) => {
      if (key === "email") {
        return {
          ...acc,
          fields: [
            {
              name: key,
              value,
            },
          ],
        };
      }

      return acc;
    }, {});

    try {
      const response = await fetch(requestURL, {
        ...requestOptions,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "LEGAL_CONSENT.subscription_type_8098782": true,
          context: {
            hutk: "71984246eae633afb1ca20e903d7b50b",
            ...getCurrentPageInfo(),
          },
          ...formattedData,
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      setShowSubmitSuccess(true);
    } catch (err) {
      console.error("Submission Failed", err.message);
      setShowSubmitSuccess(false);
    }
  }

  return (
    <SubscriptionCard key="form">
      <iframe
        title="sf-blog-subscribe"
        id="sf-blog-subscribe"
        name="sf-blog-subscribe"
        src="about:blank"
        style={{ display: "none" }}
      />
      <CardContent className="form-card" onSubmit={submitForm}>
        <input
          type="hidden"
          name="LEGAL_CONSENT.subscription_type_8098782"
          value="true"
        />
        {formIndex >= 2 && (
          <FormHeaderContainer>
            <SubscribeIcon type="EmailSubscribe" />
            <SubscribeTitle>Join our newsletter</SubscribeTitle>
            <SubscribeSubtitle>
              Get the latest Savant updates, delivered to your inbox.
            </SubscribeSubtitle>
          </FormHeaderContainer>
        )}
        <FormContentContainer>
          {!showSubmitSuccess ? (
            <FormGroup>
              {formIndex < 2 && (
                <SubscribeTitle className="form-subscription-subtitle">
                  Join our newsletter
                </SubscribeTitle>
              )}
              <FormRow>
                <FormTextInput
                  placeholder="email*"
                  pattern={REGEX_VALIDATION_PATTERNS.EMAIL}
                  id="email"
                  name="email"
                  required={true}
                  type="email"
                />
              </FormRow>
              <FormRow>
                <FormSubmitButton isSubmit={true}>Submit</FormSubmitButton>
              </FormRow>
              <FormRow>
                <FormConsentText>
                  By subscribing above, you agree to receive marketing
                  communications from Savant.
                </FormConsentText>
              </FormRow>
            </FormGroup>
          ) : (
            <FormGroup className="subscribe-success-group">
              <SubscribeTitle style={{ margin: 0 }}>SUBSCRIBED</SubscribeTitle>
              <SubscribeSubtitle style={{ margin: 0 }}>
                Thank you for subscribing to our newsletter!
              </SubscribeSubtitle>
            </FormGroup>
          )}
        </FormContentContainer>
      </CardContent>
    </SubscriptionCard>
  );
}
